import { useChartPeriod } from '@/hooks';
import {
  CurrencyValue,
  formatCurrency,
  formatNumber,
  LineChart
} from '@blockanalitica/ui';
import { useMemo } from 'react';

export default function HistoricGraphs({
  data,
  address,
  timeFilter,
  chartDaysAgo,
  activeDisplayOption
}) {
  const [, updateChartConfigWithPeriod] = useChartPeriod(chartDaysAgo);
  const config = updateChartConfigWithPeriod();

  const valueFormatter = useMemo(() => {
    function formatValue(value: string) {
      switch (activeDisplayOption) {
        case 'total_balance':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: {
                  name: data.symbol,
                  address: address,
                  network: 'optimism'
                },
                iconSize: '3'
              }}
            />
          );
        case 'price':
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USD',
                notation: 'standard',
                formatCurrencyOptions: {
                  maximumFractionDigits: Number(value) < 1 ? 5 : 2
                }
              }}
            />
          );
        default:
          return (
            <CurrencyValue
              value={value}
              options={{
                currency: 'USD'
              }}
            />
          );
      }
    }
    return formatValue;
  }, [activeDisplayOption, data, address]);
  const yScaleValueFormatter = useMemo(() => {
    return (value) => {
      switch (activeDisplayOption) {
        case 'total_corrected':
          return `${formatNumber(Number(value))}`;
        case 'price':
          return `${formatCurrency(value, { maximumFractionDigits: 5 })}`;
        default:
          return `${formatCurrency(value)}`;
      }
    };
  }, [activeDisplayOption]);

  return (
    <LineChart
      key={activeDisplayOption}
      data={data.data}
      datasets={[
        {
          xField: 'date',
          yField: activeDisplayOption
        }
      ]}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      timeFilter={timeFilter}
      config={config}
    />
  );
}
